import React from 'react';
import PropTypes from 'prop-types';
import { INFO } from './NotificationTypes';
import Icons from './Icons';
import noop from '../tools/noop';

const typeDetails = {
  INFO: {
    icon: 'info',
  },
  ERROR: {
    icon: 'bug',
  },
  WARNING: {
    icon: 'exclamation-triangle',
  },
  SUCCESS: {
    icon: 'check',
  },
};

const Notification = (props) => {
  const {
    id,
    type = INFO,
    text = '',
    duration,
    onClose = noop,
    isClosing = false,
  } = props;

  const hasDuration = (duration !== undefined);

  let isClosingClass = '';
  if (isClosing) isClosingClass = ' is-closing';

  let durationClassName = '';
  if (!isClosing && hasDuration) durationClassName = ` duration-${duration}`;

  let timedClassName = '';
  if (hasDuration) timedClassName = ' timed';

  const { icon } = typeDetails[type];

  return (
    <div className={`message ${type.toLowerCase()}${timedClassName}${durationClassName}${isClosingClass}`}>
      <span className="message-icon">
        <Icons.Custom name={icon} />
      </span>
      <span className="text-container">
        <span className="text">{text}</span>
        <div className="progress-container"><div className="message-progress" /></div>
      </span>
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        className="close-icon"
        onClick={() => { onClose({ id }); }}
      >
        <Icons.Custom name="times" />
      </button>
    </div>
  );
};

Notification.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  isClosing: PropTypes.bool,
};

export default Notification;
